import type { FormErrors } from 'redux-form';

import type { EHSRM } from 'ab-requestModels/company.requestModel';

import { NOTION_ORGANIZATIONS, NOTION_URL } from 'ab-common/constants/company';

export function validate(form: EHSRM) {
	const { ehsUrl } = form;
	const errors: FormErrors<EHSRM> = {};

	if (!ehsUrl) {
		return errors;
	}

	// just for the lamda below, it thinks it can change and be null
	const possibleNotionOrganizationPrefixes = NOTION_ORGANIZATIONS.map((_organization) => `${NOTION_URL}/${_organization}/`);
	if (!possibleNotionOrganizationPrefixes.some((_prefix) => ehsUrl.startsWith(_prefix))) {
		errors.ehsUrl = 'Invalid EHS url';
	}
	return errors;
}
